import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import { useSelector, useDispatch } from 'react-redux';
import {
  createLoyalty,
  displayTransferBalanceModal,
  setLoyaltyRegistrationModalOpen,
} from '../loyaltyActions';
import styled from 'styled-components';
import appConfig from '../../../../app-config';
import { LoyaltyRegistrationMessages } from './LoyaltyRegistrationMessages';
import { LoyaltyRegistrationForm } from './LoyaltyRegistrationForm';
import { PrimaryButton } from '../../../components/Buttons';
import FlatButton from '../../../components/Buttons/FlatButton';
import { LoyaltyCreateNewCard } from './LoyaltyCreateNewCard';
const Wrapper = styled.div`
  width: 100%;
  padding: 20px 20px 40px 20px;
  position: relative;
`;
const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
`;
const Logo = styled.img`
  height: 110px;
  @media (max-width: 786px) {
    order: -1;
  }
`;
const MessageWrapper = styled.div`
  padding: 0 16px;
  margin-bottom: 15px;
`;
const FormWrapper = styled.div`
  padding: 0 25px;
  margin-bottom: 15px;
`;
const ActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${(props) => props.marginTop || '30px'};
`;
const LinkCardButton = styled(PrimaryButton)`
  padding: 20px 16px 18px 24px;
  font-size: 19px;
  font-weight: 600;
  text-transform: uppercase;
  &:hover {
    transition: all 0.25s ease;
  }
`;

const NewCardButton = styled(FlatButton)`
  padding: 14px 16px 8px 16px;
  font-size: 17px;
  font-weight: 600;
  text-transform: uppercase;
  margin-top: 20px;
  border: 1px solid #000;
  border-radius: 5px;
  min-width: 280px;
  vertical-align: middle;
  &:hover {
    transition: all 0.25s ease;
  }
`;
const SkipButton = styled(FlatButton)`
  color: ${(props) => props.theme.primaryColor};
  padding: 8px 16px;
  font-size: 17px;
  font-weight: 600;
  margin-top: 20px;
  &:hover {
    transition: all 0.25s ease;
  }
`;
const CloseIcon = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color: white;
  background-color: rgba(81, 78, 89, 0.63);
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.closeButtonHoverColor};
    transition: all 0.25s ease;
  }
`;
export const LoyaltyRegistrationContainer = () => {
  const dispatch = useDispatch();
  const [registrationStep, setRegistrationStep] = useState('welcome');
  const { isLoyaltyRegistrationModalOpen } = useSelector(
    (state) => state.loyaltyReducer
  );
  const handleCloseModal = () => {
    dispatch(setLoyaltyRegistrationModalOpen(false));
  };
  const handleAddNewDigitalCard = () => {
    setRegistrationStep('new_card');
    dispatch(createLoyalty());
  };
  return (
    <Dialog
      id='Auth-AuthContainer-Dialog'
      aria-labelledby='payment-methods'
      aria-describedby='payment-methods'
      open={isLoyaltyRegistrationModalOpen}
      onBackdropClick={handleCloseModal}
      fullWidth={window.innerWidth < 786}
      fullScreen={typeof window !== 'undefined' && window.innerWidth < 786}
      PaperProps={{ style: { zIndex: 1000, borderRadius: 20 } }}
      scroll='body'
    >
      <Wrapper>
        <CloseIcon onClick={handleCloseModal}>
          <i className='fal fa-times' />
        </CloseIcon>
        <LogoWrapper>
          <Logo src={appConfig.styleConfig.logoUrl} />
        </LogoWrapper>
        <MessageWrapper>
          <LoyaltyRegistrationMessages registrationStep={registrationStep} />
        </MessageWrapper>
        {registrationStep === 'new_card' && (
          <LoyaltyCreateNewCard handleCloseModal={handleCloseModal} />
        )}
        {registrationStep === 'link' && (
          <FormWrapper>
            <LoyaltyRegistrationForm
              handleCloseModal={handleCloseModal}
              setRegistrationStep={setRegistrationStep}
            />
          </FormWrapper>
        )}
        {registrationStep === 'welcome' && (
          <ActionWrapper
            marginTop={registrationStep === 'welcome' ? '100px' : undefined}
          >
            <LinkCardButton
              id='ExistingGiftCard-AddGiftCard'
              type='submit'
              onClick={() => {
                setRegistrationStep('link');
              }}
            >
              I HAVE A LOYALTY CARD
            </LinkCardButton>
            <NewCardButton
              id='ExistingGiftCard-AddGiftCard'
              type='submit'
              onClick={handleAddNewDigitalCard}
            >
              CREATE A LOYALTY CARD FOR ME
            </NewCardButton>
            <SkipButton
              id='ExistingGiftCard-AddGiftCard'
              type='submit'
              onClick={handleCloseModal}
            >
              Skip for now
            </SkipButton>
          </ActionWrapper>
        )}
      </Wrapper>
    </Dialog>
  );
};
